import React, { Component } from "react";
import Form from "../form";
import moment from "moment";
import { compose } from "redux";
import { withUrlResource, withUrlResourceTimezone } from "common/utils";
import Resource from "common/components/Resource";
import client from "common/admin/client";
import { transformApiError } from "common/api/errors";
import { map } from "lodash";
import { getItem, localStorage } from "common/storage";
import { AppValues } from "common/constants";

class EditNotification extends Component {
  handleSubmit = async (values, { setSubmitting, setErrors, setStatus }) => {
    const { id } = this.props.urlResource;
    const { notificationId } = this.props.match.params;

    const { target, isContest, eventId, max_registrations } = values;

    const url = `buildings/${id}/notifications/${notificationId}`;
    const formData = new window.FormData();

    const multilingual = getItem(localStorage, AppValues.multilingual) || false;

    Object.keys(values).forEach((key) => {
      if (key === "image") {
        if (values[key] && values[key] instanceof File) {
          formData.append("image", values[key]); // Ensure image is properly appended
        }
      } else if (key === "floors") {
        formData.append(
          key,
          target === "floor"
            ? values.floors
            : target === "building"
              ? map(this.floors, ({ id }) => String(id))
              : [],
        );
      } else if (key === "companies") {
        formData.append(key, target === "company" ? values.companies : []);
      } else if (key === "available_at" || key === "available_until") {
        // Format date values to ISO 8601 format
        formData.append(key, new Date(values[key]).toISOString());
      } else if (key === "isContest") {
        // Format date values to boolean
        formData.append("is_contest", isContest);
      } else if (key === "eventId") {
        // Format date values to boolean
        formData.append("event_id", eventId);
      } else if (key === "max_registrations") {
        // Format date values to boolean
        formData.append("max_registrations", max_registrations ?? null);
      } else {
        formData.append(key, values[key]); // Append the other fields
      }
    });

    formData.append("multilingual", multilingual);

    try {
      await client.patch(url, { body: formData });
      setStatus({ success: true });
    } catch (error) {
      const errors = transformApiError(error);
      setStatus({ success: false });
      setErrors(errors);
    }
    setSubmitting(false);
  };

  deleteNotification = () => {
    const { match, urlResource } = this.props;
    const { id } = urlResource;
    const url = `buildings/${id}/notifications/${match.params.notificationId}`;
    client.del(url).then(() => {
      window.location.href = `/building/${id}/notifications`;
    });
  };

  duplicateNotification = () => {
    const { match, urlResource, history } = this.props;
    const { id } = urlResource;
    history.push(
      `/${urlResource.singular}/${id}/notifications/duplicate/${match.params.notificationId}`,
    );
  };

  render() {
    const { match, urlResource } = this.props;
    const { id: resourceId, plural: resourcePlural, timezone } = urlResource;
    const ishilo = localStorage.getItem("HILO") === "true";
    const lang = localStorage.getItem("i18nLang");

    return (
      <Resource
        name={`${resourcePlural}/${resourceId}/notifications/${match.params.notificationId}`}
        queryParams={{}}
        render={(notification) => (
          <Resource
            name="floors"
            queryParams={{ building_id: urlResource.id }}
            render={(floors) => {
              this.floors = floors || [];
              return (
                <Resource
                  name="companies"
                  queryParams={{ building_id: urlResource.id }}
                  render={(companies) => {
                    this.companies = companies || [];
                    return (
                      <Form
                        isEdit
                        floors={floors}
                        companies={companies}
                        isPublished={!!notification.published_at}
                        deleteNotification={this.deleteNotification}
                        duplicateNotification={this.duplicateNotification}
                        handleSubmit={this.handleSubmit}
                        timezone={timezone}
                        lang={lang}
                        initialValues={{
                          title: notification.title,
                          rsvp_form_url: notification.rsvp_form_url ?? "",
                          rsvp_button_text: notification.rsvp_button_text ?? "",
                          description: notification.description,
                          html_content: notification.html_content,
                          image: notification.image,
                          send_push_notification:
                            notification.send_push_notification,
                          target: notification.target,
                          floors: notification.floors,
                          companies: notification.companies,
                          buildings: [urlResource.id],
                          available_at: moment(notification.available_at)
                            .tz(timezone)
                            .set({
                              seconds: 0,
                              milliseconds: 0,
                            }),
                          available_until: moment(notification.available_until)
                            .tz(timezone)
                            .set({
                              seconds: 0,
                              milliseconds: 0,
                            }),
                          n_type: notification.n_type || "NOTIFICATION",
                          ishilo,
                          max_registrations:
                            notification.published_at &&
                            (notification.max_registrations === 0 ||
                              notification.max_registrations === null ||
                              notification.max_registrations === undefined)
                              ? null
                              : (notification.max_registrations ?? null),
                          isContest: notification.is_contest || false,
                          eventId: notification.event_id || null,
                        }}
                      />
                    );
                  }}
                />
              );
            }}
          />
        )}
      />
    );
  }
}

const enhanced = compose(withUrlResource, withUrlResourceTimezone);

export default enhanced(EditNotification);
